import * as am4core from '@amcharts/amcharts4/core';
import { PCI_TEXT_COLOR_DARK } from 'constants/styles';

export const am4themesDark = (target: unknown) => {
  if (target instanceof am4core.InterfaceColorSet) {
    target.setFor('grid', PCI_TEXT_COLOR_DARK);
    target.setFor('text', PCI_TEXT_COLOR_DARK);
  }
};
